import {
  ProjectsIcon,
  ResponsibilityIcon,
  RoleIcon,
} from './CompanyIcons';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';
import './style.css';

const Company = () => {
  return (
    <section className="section company" id="about">
      <div className="container">
        <div className="company__wrapper">
          <HomeSectionAccordion
            id="about"
            title="О компании"
            summary="Специализированная студия по подготовке документации и BIM-моделей по данным лазерного сканирования"
            summaryClassName="company__eyebrow"
            summaryContainerClassName="company__hero"
          >
            <div className="company__frame">
            <div className="company__stack">
              <article className="company__block">
                <div className="company__icon">
                  <RoleIcon />
                </div>

                <div className="company__content">
                  <h2 className="company__card-title">Наша роль</h2>

                  <p className="company__card-text">
                    Выступаем как внешний технический партнёр по разработке проектной документации
                    и BIM-моделей.
                  </p>
                </div>
              </article>

              <article className="company__block">
                <div className="company__icon">
                  <ResponsibilityIcon />
                </div>

                <div className="company__content">
                  <h2 className="company__card-title">Что мы делаем</h2>

                  <p className="company__card-text">
                    Вы предоставляете результаты съёмки — мы берём на себя обработку данных, анализ
                    геометрии и создание проектной документации и BIM-моделей.
                  </p>
                </div>
              </article>

              <article className="company__block">
                <div className="company__icon">
                  <ProjectsIcon />
                </div>

                <div className="company__content">
                  <h2 className="company__card-title">С чем работаем</h2>

                  <p className="company__card-text">
                    Работаем с существующими зданиями и проектами реконструкции различной сложности,
                    обеспечивая точную основу для дальнейшего проектирования.
                  </p>
                </div>
              </article>
            </div>
            </div>
          </HomeSectionAccordion>
        </div>
      </div>
    </section>
  );
};

export default Company;
